// SIMPLIFIED VERSION FOR TESTING
class ScrollToTop {
  constructor() {
    this.button = document.querySelector('.scroll-to-top__btn');
    this.container = document.querySelector('.scroll-to-top');
    
    console.log('ScrollToTop init - button:', this.button);
    console.log('ScrollToTop init - container:', this.container);
    
    if (this.button && this.container) {
      this.init();
    } else {
      console.log('Missing elements - button:', !!this.button, 'container:', !!this.container);
    }
  }

  init() {
    console.log('Initializing scroll to top');
    
    // Show button immediately for testing
    this.button.classList.add('scroll-to-top__btn--visible');
    this.container.classList.add('scroll-to-top--enabled');
    
    // Add click handler
    this.button.addEventListener('click', (e) => {
      e.preventDefault();
      console.log('Button clicked - scrolling to top');
      window.scrollTo({ top: 0, behavior: 'smooth' });
    });
    
    console.log('Button should now be visible and clickable');
  }
}

// Initialize immediately
console.log('Script loaded - DOM ready state:', document.readyState);

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => {
    console.log('DOM loaded - initializing ScrollToTop');
    new ScrollToTop();
  });
} else {
  console.log('DOM already ready - initializing ScrollToTop immediately');
  new ScrollToTop();
}